<template>
  <v-autocomplete
    :items="cities"
    item-text="name"
    @change="handleSelect"
    :loading="loading"
    :value="city"
    v-bind="$props"
    :disabled="!country_area"
    :hint="
      !country_area
        ? capitalize($tc('model.address_message_first_pick_a_country_area'))
        : ''
    "
    persistent-hint
    return-object
  ></v-autocomplete>
</template>

<script>
import { getCities } from "../../services/locals";

export default {
  name: "select-city",
  props: {
    city: Object,
    country_area: Object,
    label: String,
    clearable: Boolean,
    "error-messages": Array,
    name: String,
    autocomplete: String,
  },
  model: {
    prop: "city",
    event: "change",
  },
  data: () => ({
    cities: [],
    loading: false,
  }),
  methods: {
    capitalize: function (s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    async getCities(country_area) {
      this.loading = true;
      this.cities = await getCities(country_area.id);
      this.loading = false;
    },
    handleSelect(value) {
      this.$emit("change", value);
    },
  },
  created() {
    if (!this.country_area) {
      this.cities = [];
    } else {
      this.getCities(this.country_area);
    }
  },
  watch: {
    country_area: function (value, old_value) {
      if (!value) {
        this.cities = [];
      } else {
        this.getCities(value);
      }

      if (old_value) {
        this.$emit("change", null);
      }
    },
  },
};
</script>